import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';
import CaptureOptionsModal from './captureOptionsModal/captureOptionsModal';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fab: {
      margin: theme.spacing(1),
    },
    disabled: {
      margin: theme.spacing(1),
      backgroundColor: 'gray',
      pointerEvents: 'none',
    },
  })
);

export default function CaptureButton() {
  const classes = useStyles();
  const [show, setShow] = React.useState(false);
  const { hasMainVideo } = useVideoContext();

  const handleClick = () => {
    if (hasMainVideo) setShow(!show);
  };

  return (
    <>
      <Tooltip
        title={hasMainVideo ? 'Capture' : 'No Video Source to Capture'}
        onClick={handleClick}
        placement="top"
        PopperProps={{ disablePortal: true }}
        style={{ cursor: !hasMainVideo ? 'not-allowed' : 'pointer' }}
      >
        <div>
          <Fab className={hasMainVideo ? classes.fab : classes.disabled} color="primary">
            <PhotoCamera />
          </Fab>
        </div>
      </Tooltip>
      {show && <CaptureOptionsModal show={show} setShow={setShow} />}
    </>
  );
}
